import { render, staticRenderFns } from "./DraftSourcesList.vue?vue&type=template&id=f849d56c&"
import script from "./DraftSourcesList.vue?vue&type=script&lang=js&"
export * from "./DraftSourcesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports